import { callNative } from '@/shared/utils/bridge';
import { canDownloadFirstUse } from '@/shared/tools/ocr/utils/env';

/**
 * 优先下载OCR SDK动态资源
 * 非阻塞，内部逻辑在调用下载前，会先判断OCR SDK是否已安装
 * 已安装则返回hasInstalled=true，未安装返回已安装则返回hasInstalled=false，并开始安装
 * */
export const downloadOcrSDKFirst = (): Promise<{
  hasInstalled: boolean;
}> => {
  if (canDownloadFirstUse) {
    try {
      return callNative({
        classMap: 'business/finance',
        method: 'downloadOCRSDKFirst',
      });
    } catch {
      // 暂不处理，不阻塞流程
    }
  }

  return Promise.resolve({ hasInstalled: false });
};
